// PROFORT — scripts propios, vanilla JS, sin dependencias externas.

function pfInitReveals() {
  const els = document.querySelectorAll('.pf-reveal, .pf-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('pf-visible'));
    return;
  }
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('pf-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el) => obs.observe(el));
}

function pfInitGaleriaProducto() {
  const wraps = document.querySelectorAll('[data-pf-galeria]');
  wraps.forEach((wrap) => {
    const principal = wrap.querySelector('[data-pf-imagen-principal]');
    const minis = wrap.querySelectorAll('[data-pf-mini]');
    if (!principal || !minis.length) return;
    minis.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        minis.forEach((m) => m.classList.remove('pf-activa'));
        mini.classList.add('pf-activa');
      });
    });
  });
}

function pfInitVariantes() {
  const forms = document.querySelectorAll('[data-pf-producto-form]');
  forms.forEach((formWrap) => {
    const dataEl = formWrap.querySelector('[data-pf-variantes-json]');
    if (!dataEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const idInput = formWrap.querySelector('input[name="id"]');
    const precioActual = formWrap.querySelector('[data-pf-precio-actual]');
    const precioAntes = formWrap.querySelector('[data-pf-precio-antes]');
    const descuento = formWrap.querySelector('[data-pf-descuento]');
    const botonAnadir = formWrap.querySelector('[data-pf-anadir]');
    const sizeMsg = formWrap.querySelector('[data-pf-size-msg]');
    const grupos = formWrap.querySelectorAll('[data-pf-opcion-grupo]');

    function opcionesSeleccionadas() {
      const seleccion = [];
      grupos.forEach((grupo) => {
        const activo = grupo.querySelector('.pf-seleccionado');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      const seleccion = opcionesSeleccionadas();
      return variantes.find((v) => v.options.every((op, i) => op === seleccion[i]));
    }

    function actualizarDisponibilidad() {
      grupos.forEach((grupo, indiceGrupo) => {
        const botones = grupo.querySelectorAll('[data-pf-opcion-valor]');
        botones.forEach((btn) => {
          const valor = btn.getAttribute('data-valor');
          const seleccionParcial = opcionesSeleccionadas();
          seleccionParcial[indiceGrupo] = valor;
          const existe = variantes.some((v) =>
            v.options.every((op, i) => seleccionParcial[i] === null || op === seleccionParcial[i])
          );
          btn.disabled = !existe;
        });
      });
    }

    function actualizarEtiquetas() {
      grupos.forEach((grupo) => {
        const activo = grupo.querySelector('.pf-seleccionado');
        const elegido = grupo.querySelector('[data-pf-opcion-elegido]');
        if (elegido && activo) elegido.textContent = activo.getAttribute('data-valor');
      });
    }

    function actualizarDescuento(variante) {
      if (!descuento) return;
      const precio = Number(variante.price_cents) || 0;
      const antes = Number(variante.compare_cents) || 0;
      if (antes > precio && precio > 0) {
        const pct = Math.round((1 - precio / antes) * 100);
        descuento.textContent = '-' + pct + '%';
        descuento.hidden = false;
      } else {
        descuento.hidden = true;
      }
    }

    function actualizarMensajeTalla(variante) {
      if (!sizeMsg) return;
      const seleccion = opcionesSeleccionadas();
      const talla = seleccion.length ? seleccion[seleccion.length - 1] : '';
      if (!variante || !variante.available) { sizeMsg.textContent = ''; sizeMsg.classList.remove('pf-visible'); return; }
      const umbral = Number(sizeMsg.getAttribute('data-umbral')) || 0;
      const inv = Number(variante.inventory) || 0;
      let txt;
      if (umbral > 0 && inv > 0 && inv <= umbral) {
        txt = (sizeMsg.getAttribute('data-plantilla-bajo') || '')
          .replace('[TALLA]', talla).replace('[N]', inv);
        sizeMsg.classList.add('pf-bajo');
      } else {
        txt = (sizeMsg.getAttribute('data-plantilla-ok') || '').replace('[TALLA]', talla);
        sizeMsg.classList.remove('pf-bajo');
      }
      sizeMsg.textContent = txt;
      sizeMsg.classList.add('pf-visible');
    }

    function actualizarUI() {
      actualizarEtiquetas();
      const variante = encontrarVariante();
      if (!variante) {
        if (botonAnadir) {
          botonAnadir.disabled = true;
          botonAnadir.textContent = botonAnadir.getAttribute('data-texto-no-disponible') || 'No disponible';
        }
        if (sizeMsg) { sizeMsg.textContent = ''; sizeMsg.classList.remove('pf-visible'); }
        actualizarDisponibilidad();
        return;
      }
      if (idInput) idInput.value = variante.id;
      if (precioActual) precioActual.textContent = variante.price_formatted;
      if (precioAntes) {
        if (variante.compare_at_price_formatted) {
          precioAntes.textContent = variante.compare_at_price_formatted;
          precioAntes.style.display = '';
        } else {
          precioAntes.style.display = 'none';
        }
      }
      actualizarDescuento(variante);
      actualizarMensajeTalla(variante);
      if (botonAnadir) {
        if (variante.available) {
          botonAnadir.disabled = false;
          botonAnadir.textContent = botonAnadir.getAttribute('data-texto-normal') || 'Añadir al carrito';
        } else {
          botonAnadir.disabled = true;
          botonAnadir.textContent = botonAnadir.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
      actualizarDisponibilidad();
    }

    grupos.forEach((grupo) => {
      const botones = grupo.querySelectorAll('[data-pf-opcion-valor]');
      botones.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          botones.forEach((b) => b.classList.remove('pf-seleccionado'));
          btn.classList.add('pf-seleccionado');
          actualizarUI();
        });
      });
    });

    // Preselección de color desde la URL (?color=...) — miniaturas de la home/ficha
    try {
      const params = new URLSearchParams(window.location.search);
      const colorParam = params.get('color');
      if (colorParam) {
        for (const grupo of grupos) {
          const match = [...grupo.querySelectorAll('[data-pf-opcion-valor]')]
            .find((b) => b.getAttribute('data-valor') === colorParam);
          if (match) {
            grupo.querySelectorAll('[data-pf-opcion-valor]').forEach((b) => b.classList.remove('pf-seleccionado'));
            match.classList.add('pf-seleccionado');
            break;
          }
        }
      }
    } catch (e) { /* noop */ }

    actualizarUI();
  });
}

function pfInitCountdown() {
  const cajas = document.querySelectorAll('[data-pf-countdown]');
  cajas.forEach((caja) => {
    const timer = caja.querySelector('[data-pf-timer]');
    if (!timer) return;
    function dos(n) { return String(n).padStart(2, '0'); }
    function tick() {
      const ahora = new Date();
      const fin = new Date(ahora);
      fin.setHours(24, 0, 0, 0); // próxima medianoche local
      let seg = Math.max(0, Math.floor((fin - ahora) / 1000));
      const h = Math.floor(seg / 3600); seg -= h * 3600;
      const m = Math.floor(seg / 60); const s = seg - m * 60;
      timer.textContent = dos(h) + ':' + dos(m) + ':' + dos(s);
    }
    tick();
    setInterval(tick, 1000);
  });
}

function pfInitGuiaTallas() {
  const modal = document.querySelector('[data-pf-guia-modal]');
  if (!modal) return;
  const abrir = document.querySelectorAll('[data-pf-guia-abrir]');
  const cerrar = modal.querySelectorAll('[data-pf-guia-cerrar]');
  function abrirModal() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
  function cerrarModal() { modal.hidden = true; document.body.style.overflow = ''; }
  abrir.forEach((b) => b.addEventListener('click', abrirModal));
  cerrar.forEach((b) => b.addEventListener('click', cerrarModal));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) cerrarModal(); });
}

function pfInitResenasArrastre() {
  const tracks = document.querySelectorAll('[data-pf-resenas-track]');
  tracks.forEach((track) => {
    let isDown = false;
    let startX;
    let scrollLeft;
    const wrap = track.parentElement;
    wrap.style.overflowX = 'auto';
    wrap.style.scrollBehavior = 'smooth';
    wrap.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - wrap.offsetLeft;
      scrollLeft = wrap.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach((evt) => wrap.addEventListener(evt, () => (isDown = false)));
    wrap.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrap.offsetLeft;
      wrap.scrollLeft = scrollLeft - (x - startX) * 1.2;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  pfInitReveals();
  pfInitGaleriaProducto();
  pfInitVariantes();
  pfInitCountdown();
  pfInitGuiaTallas();
  pfInitResenasArrastre();
});
